import { useEffect, useState } from 'react';

import type { InputProps } from '../type';

export type CounterInputProps = InputProps & {
  count: number;
  max: number;
  min: number;
  onCountChange?: (count: number) => void;
};

export function useCounterInput({ count: value, max, min, onCountChange, className, ...rest }: CounterInputProps) {
  const [state, setState] = useState({ count: value, inputValue: value.toString() });

  useEffect(() => {
    if (value !== state.count) {
      setState({ count: value, inputValue: value.toString() });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const decrement = () => {
    if (state.count <= min) {
      return;
    }

    const newCount = state.count - 1;
    setState({ count: newCount, inputValue: newCount.toString() });
    handleChangeCount(newCount);
  };

  const increment = () => {
    if (state.count >= max) {
      return;
    }

    const newCount = state.count + 1;

    setState({ count: newCount, inputValue: newCount.toString() });
    handleChangeCount(newCount);
  };

  const handleBlur = () => {
    let num = parseInt(state.inputValue, 10);
    num = num > max ? max : num;
    num = num < min ? min : num;

    if (Number.isNaN(num) === true) {
      setState({ count: state.count, inputValue: state.count.toString() });
    } else {
      setState({ count: num, inputValue: num.toString() });
      handleChangeCount(num);
    }
  };

  const handleChangeCount = (v: number) => {
    if (onCountChange !== undefined) {
      onCountChange(v);
      return v;
    }
    return false;
  };

  const handleChangeInput = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    setState((s) => ({ ...s, inputValue: target.value }));
  };

  return {
    inputValue: state.inputValue,
    min,
    decrement,
    increment,
    handleChangeInput,
    handleBlur,
    className,
    rest,
  };
}
